const WIKI_LINK_PATTERN = /\[\[([^\]|]+)(\|[^\]]+)?\]\]/g

export function renameWikiPageReferences(
  body: string,
  previousTitle: string,
  nextTitle: string,
  pageId?: string
): string {
  const normalizedPreviousTitle = previousTitle.trim().toLowerCase()

  if (!body || !normalizedPreviousTitle || !nextTitle) return body

  return body.replace(WIKI_LINK_PATTERN, (link, target: string, labelSuffix?: string) => {
    const normalizedTarget = target.trim().toLowerCase()
    if (normalizedTarget === normalizedPreviousTitle) {
      return `[[${nextTitle}${labelSuffix ?? ''}]]`
    }

    const referencedPageId = target.trim().startsWith('wiki:') ? target.trim().split(':')[2] : null
    const label = labelSuffix?.slice(1).trim()
    if (pageId && referencedPageId === pageId && label?.toLowerCase() === normalizedPreviousTitle) {
      return `[[${target}|${nextTitle}]]`
    }

    return link
  })
}
